import xhr from '../xhr';

export function updateHeaderMessageCounter() {
    const buttons = Array.from(document.querySelectorAll('.js-header-pms-button'));
    if(buttons.length > 0)
        xhr.get('/messages/stats', { type: 'json' }).then(result => {
            const body = result.body;
            if(typeof body === 'object' && typeof body.unread === 'number')
                if(body.unread > 0) {
                    const count = body.unread.toLocaleString();
                    for(const button of buttons)
                        button.append(<div class="header__desktop__user__button__count">{count}</div>);
                }
        });
}
